<template>
<div class="input-container" data-component="FormInput.vue">
	<input
		ref="input"
		class="inputText"
		required
		:type="type"
		:value="modelValue"
		:name="name"
		:autocomplete="htmlAttributeAutocomplete"
		@input="$emit('update:modelValue', $event.target.value)"
		@keyup="$emit('keyup', $event.target.value)"
		@keydown="PreventKeyCode"
	>
	<span class="floating-label">{{ placeholder }}</span>
</div>
</template>

<script lang="ts">
import { onlyNumber } from '@globals/utilities/InputEventUtils';

export default {
	name: 'FormInput',
	props: {
		type: {
			type: String,
			default: 'text',
		},
		placeholder: String,
		name: String,
		focus: Boolean,
		modelValue: [String, Number],
		htmlAttributeAutocomplete: { default: 'off', type: String },
	},
	emits: ['update:modelValue', 'keyup'],
	mounted() {
		if (this.focus) {
			this.focusInput();
		}
	},
	methods: {
		focusInput() {
			this.$refs.input.focus();
		},
		PreventKeyCode(e: any) {
			if (this.type === 'number' || this.type === 'tel') {
				if (this.type === 'tel' && e.key !== '+') onlyNumber(e);
			}
		},
		OnlyNumber(e: any) {
			onlyNumber(e);
		},
	},
};
</script>

<style scoped lang="scss">
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
	border: 1px solid #E7760D;
	-webkit-box-shadow: 0 0 0 1000px #fff inset;
	-webkit-text-fill-color: black;
}

.input-container {
	position: relative;
	width: 100%;

	input {
		width: 100%;
		font-size: 14px;

		&:focus {
			border-color: #E7760D;
		}
	}

	.floating-label {
		position: absolute;
		top: 18px;
		left: 12px;
		color: #979797;
		pointer-events: none;
		transition: 0.2s ease all;
	}
}

input:focus ~ .floating-label,
input:not(:focus):valid ~ .floating-label {
	z-index: 5;
	top: -9px;
	left: 10px;
	height: 20px;
	padding: 0 3px;
	background: linear-gradient(transparent 45%, #fff 20%);
	caret-color: #E7760D;
	color: #E7760D;
	font-size: 12px;
	opacity: 1;
}
</style>
